import React from 'react';
import { i18n } from 'utils/i18n';
import Modal from 'components/Modal';
import MODAL, { MODAL_THEMES } from 'constants/modals';
import RemoveCIDModalContent from 'components/ReservationFlow/SharedModals/RemoveCIDModalContent';

const RemoveCIDModal = () => (
  <Modal
    modalKey={MODAL.REMOVE_CID_MODAL}
    header={i18n('progress_bar_cid_remove_modal_title')}
    theme={MODAL_THEMES.WHITE}
  >
    <RemoveCIDModalContent />
  </Modal>
);

export default RemoveCIDModal;
